// @flow
import React from 'react';
import classNames from 'classnames';
import SimpleBar from 'simplebar-react';
import { HTMLView } from 'components/atoms/htmlView';
import { useViewport } from 'components/templates/viewportProvider';
// eslint-ignore-next-line
import styles from './styles.scss';

type Props = {
  data: {
    html: string,
    className?: string,
  },
};

export const StaticContentSection = (props: Props) => {
  const { isMobile } = useViewport();
  const { html, isScroll, className = '', toggleId } = props.data;

  let containerClassName = 'static-content';
  let contentClass = 'content';
  if (isScroll) {
    containerClassName = 'static-content';
    contentClass = 'content';
    if (isMobile) {
      containerClassName = 'static-content';
      contentClass = 'content-mobile';
    }
  } else if (!isScroll) {
    containerClassName = 'static-content';
    contentClass = 'content';
    if (isMobile) {
      contentClass = 'content-mobile';
    }
  }

  const containerClass = classNames(containerClassName, className);

  return (
    <div className={containerClass} id={toggleId ? 'privacy-policy' : 'terms'}>
      <HTMLView html={html} tagName={'div'} className={contentClass} />
    </div>
  );
};
